import {
    createSlice,
    createEntityAdapter,
} from '@reduxjs/toolkit';
import { nonTradingEventUpdate } from '~SpectateStore/actions/nonTradingEventUpdate';
import { inplayEventData } from '~SpectateStore/thunks/inplayEventData';
import { eventUpdate } from '~SpectateStore/actions/eventUpdate';
import { eventDataCleanUp } from '~SpectateStore/actions/eventDataCleanUp';
import { eventInplayStart } from '~SpectateStore/actions/eventInplayStart';
import { eventRescheduled } from '~spa/SpectateStore/actions/eventRescheduled';
import {
    moreGamesCleanUp,
    moreGamesUpdate,
} from '~SpectateStore/actions/moreGamesActions';
import {
    dataPointersUpdate,
    dataPointersCleanUp,
} from '~SpectateStore/actions/dataPointersActions';


export const eventsAdapter = createEntityAdapter();

const eventsSlice = createSlice({
    name: 'events',
    initialState: eventsAdapter.getInitialState(),
    reducers: {
        addEvent: eventsAdapter.addOne,
        removeEvent: eventsAdapter.removeOne,
        updateSelectedMarketGroup: (state, { payload: { eventId, slug }}) => {
            state.entities[eventId]['selected_tab'] = slug;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(
                eventDataCleanUp,
                (state, { payload : { eventId } }) => {
                    eventsAdapter.removeOne(state, eventId);
                },
            )
            .addCase(
                inplayEventData.fulfilled,
                (state, { payload : { event } }) => {
                    if (Object.keys(event).length > 0) {
                        return eventsAdapter.upsertOne(state, event);
                    }

                    return state;
                },
            )
            .addCase(
                nonTradingEventUpdate,
                (state, { payload : { event } }) => {
                    return eventsAdapter.upsertOne(state, event);
                },
            )
            .addCase(
                eventUpdate,
                (state, { payload : { event } }) => {
                    return eventsAdapter.upsertOne(state, event);
                },
            )
            .addCase(
                eventRescheduled,
                (state, { payload : { eventId, rescheduledTime } }) => {
                    eventsAdapter.updateOne(state, {
                        id: eventId,
                        changes: { scheduled_start_time: rescheduledTime },
                    });
                },
            )
            .addCase(
                moreGamesUpdate,
                (state, { payload : { events } }) => {
                    eventsAdapter.upsertMany(state, events);
                },
            )
            .addCase(
                moreGamesCleanUp,
                (state, { payload : { eventsIds } }) => {
                    eventsAdapter.removeMany(state, eventsIds);
                },
            )
            .addCase(
                dataPointersUpdate,
                (state, { payload : { events = {} } }) => {
                    if (Object.keys(events).length > 0) {
                        return eventsAdapter.upsertMany(state, events);
                    }

                    return state;
                },
            )
            .addCase(
                dataPointersCleanUp,
                (state, { payload: { dataPointers } }) => {
                    if (!dataPointers) {
                        return state;
                    }

                    const eventIds = dataPointers.reduce((ids, { event_id }) => [...ids, event_id], []);
                    if (eventIds.length > 0) {
                        return eventsAdapter.removeMany(state, eventIds);
                    }

                    return state;
                },
            )
            .addCase(
                eventInplayStart,
                (state, { payload : { events } }) => {
                    return eventsAdapter.upsertMany(state, events);
                }
            );
    },
});

export const { addEvent, removeEvent, updateSelectedMarketGroup } = eventsSlice.actions;
export default eventsSlice.reducer;
